import React from 'react';
import { cn } from '../../../lib/utils';
import { formatTime } from '../../../lib/gameUtils';

export function GameStats({ time, moves, isLandscape = false, variant = 'mobile' }) {
  const isMobile = variant === 'mobile';
  
  return (
    <>
      {/* Time */}
      <div className={cn(
        "flex flex-col items-center",
        isMobile && isLandscape && "flex-row gap-1"
      )}>
        <span className={cn(
          "text-muted-foreground uppercase tracking-wider",
          isMobile ? (isLandscape ? "text-[9px]" : "text-[10px]") : "text-xs"
        )}>
          Time
        </span>
        <span className={cn(
          "font-heading font-semibold tabular-nums",
          isMobile ? (isLandscape ? "text-sm" : "text-base") : "text-xl"
        )}>
          {formatTime(time)}
        </span>
      </div>
      
      {/* Moves */}
      <div className={cn(
        "flex flex-col items-center",
        isMobile && isLandscape && "flex-row gap-1"
      )}>
        <span className={cn(
          "text-muted-foreground uppercase tracking-wider",
          isMobile ? (isLandscape ? "text-[9px]" : "text-[10px]") : "text-xs"
        )}>
          Moves
        </span>
        <span className={cn(
          "font-heading font-semibold tabular-nums",
          isMobile ? (isLandscape ? "text-sm" : "text-base") : "text-xl"
        )}>
          {moves}
        </span>
      </div>
    </>
  );
}
